
import {buildScaleFromInterpolators, interpolatorsFrom, smooth} from "./palette.js";

export function createUVIPalette(resolution = 10000) {
    const bounds = [0, 18/40];  // units: W/m^2 == UVIndex/40

    const stops = [
        {color: [  0,   0,  15], mode: "hsl", p: bounds[0]}, // night
        {color: [ 32,  32,  32], mode: "hsl", p: 0.005},     // terminator
        {color: [ 62, 167,  45], mode: "hsl", p: 0.5/40},    // green  [low: 0-2]
        {color: [255, 238,   0], mode: "hsl", p: 3.5/40},    // yellow [moderate: 3-5]
        {color: [241, 139,   0], mode: "hsl", p: 6.25/40},   // orange [high: 6-7]
        {color: [229,  50,  16], mode: "hsl", p: 8.5/40},    // red    [very high: 8-10]
        {color: [181, 103, 164], mode: "hsl", p: 11/40},     // purple [extreme: 11+]
        {color: [231, 225, 255], mode: "hsl", p: bounds[1]}, // white  [very extreme]
    ];

    let interpolators = interpolatorsFrom(stops);
    interpolators = smooth(interpolators, 1, [0.25/40, 1.0/40]);
    interpolators = smooth(interpolators, 3, [2.5/40, 4.5/40]);
    return buildScaleFromInterpolators(bounds, interpolators, resolution);
}
